var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66146 0.55249C7.43213 0.55249 9.05612 1.4123 10.1039 2.82717C11.1516 1.4123 12.7756 0.55249 14.5463 0.55249C17.6423 0.55249 20.1621 3.18089 20.1621 6.41334C20.1621 7.93161 19.6068 9.37369 18.5957 10.4729L10.6749 18.7826L10.1039 19.3812L9.53284 18.7826L1.76389 10.6308C0.663767 9.52607 0.0456047 8.02412 0.0456047 6.41334C0.0456047 3.18089 2.56541 0.55249 5.66146 0.55249Z",
    fill: "#0a1d47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillHeart);
export default __webpack_public_path__ + "static/media/fillHeart.a2b386df065fd39bc246879d3615c5eb.svg";
export { ForwardRef as ReactComponent };